import { ApplicationPartialStoreState, APPLICATION_STATE_KEY } from './application.reducer';

export const getHighContrast = (state: ApplicationPartialStoreState) => state[APPLICATION_STATE_KEY].highContrast;
export const getTermsUrl = (state: ApplicationPartialStoreState) => state[APPLICATION_STATE_KEY].termsUrl;
export const getAssetsPath = (state: ApplicationPartialStoreState) => state[APPLICATION_STATE_KEY].assetsPath;
export const getReady = (state: ApplicationPartialStoreState) => state[APPLICATION_STATE_KEY].ready;
export const getUserAgreedTermsVersionOnOnboarding = (state: ApplicationPartialStoreState) =>
    state[APPLICATION_STATE_KEY].userAgreedTermsVersionOnOnboarding;
